








import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { ICheckoutCartOffer } from '@/interfaces/Checkout';

import DiscountContent from './DiscountContent.vue';

const CheckoutModule = namespace('App/Checkout');

@Component({
  components: {
    DiscountContent,
  }
})
export default class DiscountContainer extends Vue {
  @CheckoutModule.Getter('selectedOffer')
  private readonly offer!: ICheckoutCartOffer;

  private get messages(): string[] {
    if (this.offer.discounts) {
      const { discounts } = this.offer.discounts;

      return discounts.filter(item => Boolean(item.checkout_message)).map(item => item.checkout_message);
    }

    return [];
  }

  private get hasMessages(): boolean {
    return Boolean(this.messages.length);
  }
}
